<!-- app.vue -->
<template>
  <div>
    <NuxtLayout>
      <NuxtRouteAnnouncer />
      <NuxtPage />
    </NuxtLayout>
  </div>

  <ModalAlert />
  <GlobalToast />
</template>

<script setup>
// import { useModalStore } from "../stores/modal";

// 환경변수
const config = useRuntimeConfig();

// Store 초기화 수정
// const modalStore = useModalStore(); // .value 제거

onMounted(() => {
  console.log("=== 전체 config 확인 ===");
  console.log("config.public:", config.public);
  console.log("========================");

  console.log("API 서버:", config.public.apiServer);
  console.log("환경:", config.public.nodeEnv);

  // Store 확인 (이미 modalStore는 초기화됨)
  // console.log("Modal store 로드됨:", modalStore);
});

// 전역 에러 핸들링
const handleError = (error) => {
  console.error("Global error:", error);
  // 필요시 에러 페이지로 리다이렉트 또는 모달 표시
};

// 전역 에러 처리
onErrorCaptured((err, instance, info) => {
  console.error("Vue error captured:", err, info);
  handleError(err);
  return false; // 에러 전파 중단
});
</script>

<style>
/* 전역 스타일 */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: "Pretendard", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
    "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 포커스 표시 일관성 */
*:focus {
  outline: none;  
}

/* 스크롤바 스타일링 (Webkit) */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
